import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { router } from './app/router'
import { setupPwa } from './lib/pwa'
import './index.css'

setupPwa()

const container = document.getElementById('root')!
const renderApp = () => {
  // Título, descrição e canonical do HTML entregue saem: cada tela põe os seus (<Seo>), e
  // ficar com dois de cada confundiria buscadores que rodam JavaScript.
  document.head.querySelectorAll('title, meta[name="description"], link[rel="canonical"]').forEach((element) => element.remove())
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// Página pré-renderizada no build (scripts/prerender.mjs): o HTML dela fica na tela até a
// rota carregar, em vez de dar lugar ao "Carregando…" por um instante.
if (container.firstElementChild && !router.state.initialized) {
  const unsubscribe = router.subscribe((state) => {
    if (!state.initialized) return
    unsubscribe()
    renderApp()
  })
} else {
  renderApp()
}
